export default {
  siteName: "PixelHaha",
  creation: "Imagem de IA",
  faceSwap: "Troca de Rosto",
  product: "Produto",
  magicBrush: "Pincel Mágico",
  discover: "Descobrir",
  profile: "Perfil",
  pricing: "Preços",
  freeCredits: "Créditos Grátis",
  credits: "Créditos",
  getMoreCredits: "Obtenha mais créditos",
  left: "Esquerda",
  upgradeToPremium: "Atualizar para Premium",
  go: "Ir!",
  accountInformation: "Informação da conta",
  signOut: "Sair",
  getMore: "Pegue mais",
  contactSupport: "Contate o suporte",
  history: "Histórico",
  login: "Entrar",
  signup: "Inscrever-se",
  aiFuture: "Recurso de IA",
  photoFaceSwap: "Troca de rosto de foto",
  photoMutipleFaceSwap: "Troca de rosto de várias imagens",
  videoFaceSwap: "Criador de vídeos para troca de rosto",
  videoMutipleFaceSwap: "Troca de múltiplos rostos de vídeo",
  multipleFaceSwap: "Troca Múltipla de Rostos",
  aIImageGenerator: "Gerador de Imagens de IA",
  support: "Suporte",
  language: "língua",
  // userPolicy: "Política de Usuário",
  // privacyPolicy: "Política de Privacidade",
  // refundPolicy: "Política de Reembolso",
  userPolicy: "Termos e Condições",
  privacyPolicy: "política de Privacidade",
  refundPolicy: "Política de Reembolso",
  FLARKLaw: '18 Isenção USC 2257',
  policies: "Políticas",
  intellectual: "Direitos de Propriedade Intelectual",
  about: "Sobre nós",
  blog: "Blog",
  helpAndFAQS: "Ajuda e FAQs",
  sitemap: "Mapa do Site",
  bussiness: "Negócios",
  affiliateProgram: "Programa de Afiliados",
  api: "API",
  contactUs: "Contate-nos",
  aiFaceFunTitle: "Troca de rosto de vídeo AI on-line",
  aiFaceFunSubTitle:
    "Troque rostos instantaneamente com PixelHaha Video Face Swap. Mude os rostos em fotos e vídeos para quem você escolher. Crie memes engraçados com nosso produto baseado em IA.",
  startFaceButtonTitle: "Começar Troca de Rosto",
  details: "Detalhes  >",
  chooseFace: "Escolher rosto",
  faceSwaps: "trocas de rosto",
  tryAgain: "Tentar novamente",
  faceswapUploadArea: {
    tab1Desc1: "Carregue a foto original para trocar o rosto.",
    tab1Desc2: "Arraste e solte a foto ou escolha a foto",
    tab2Desc1: "Carregue a imagem original para trocar de rosto.",
    tab2Desc2: "Arraste e solte a imagem ou escolha a imagem",
    tab3Desc1: "Carregue o vídeo original para trocar de rosto.",
    tab3Desc2: "Arraste e solte o vídeo ou escolha o vídeo",
    tab4Desc1: "Carregue o vídeo original para trocar de rosto.",
    tab4Desc2: "Arraste e solte o vídeo ou escolha o vídeo",
    tab1title: "3 etapas para trocar rosto em fotos ou imagens online",
    tab1step1: "1. Carregue sua foto original do rosto.",
    tab1step2:
      "2. Carregue uma foto do rosto alvo da pessoa que substituirá o rosto na foto original. Você também pode escolher entre as demonstrações fotográficas fornecidas.",
    tab1step3:
      "3. Inicie o Foto de troca de rostos, visualize e baixe os resultados em HD.",
    tab2title: "3 etapas para trocar vários rostos em fotos online",
    tab2step1: "1. Carregue sua foto original do rosto.",
    tab2step2:
      "2. Carregue uma foto do rosto alvo da pessoa que substituirá o rosto na foto original. Você também pode escolher entre as demonstrações de imagens fornecidas.",
    tab2step3:
      "3. Inicie a imagem de troca de rosto e, em seguida, visualize e baixe os resultados em HD.",
    tab3title: "3 etapas para trocar rosto em vídeos online",
    tab3step1: "1. Envie seu vídeo de rosto original.",
    tab3step2:
      "2. Carregue um rosto alvo da pessoa que substituirá o rosto no vídeo original. Você também pode escolher entre as demonstrações fornecidas.",
    tab3step3:
      "3. Inicie o Video Face Swap, visualize e baixe os resultados em HD.",
    tab4title: "3 etapas para trocar rosto em vídeos online",
    tab4step1: "1. Envie seu vídeo de rosto original.",
    tab4step2:
      "2. Carregue um rosto alvo da pessoa que substituirá o rosto no vídeo original. Você também pode escolher entre as demonstrações fornecidas.",
    tab4step3:
      "3. Inicie o Video Face Swap, visualize e baixe os resultados em HD.",
    chooseFiles: "Escolher os arquivos",
    photoLimit: "Máximo de 10 MB",
    videoLimit: "Máx. 500M, 10min",
    uploading: "Enviando <xx1>",
    faceAnalyzing: "Análise facial",
    queuingAbout: "Na fila...Sobre <xx1>s",
    analyzingAbout: "Analisando...Sobre <xx1>s",
    somethingError: "Algo deu errado. Tente novamente mais tarde.",
  },

  review: {
    title: "Eles nos amam, você também vai",
    subtitle:
      "Junte-se à equipe de mais de 10.000 parceiros em todo o mundo. As recompensas que eles recebem do site são contínuas e estáveis.",
    data1: {
      title: "Eu adoro usar o PixelHaha!",
      content:
        "Eu adoro usar o PixelHaha! É a minha ferramenta favorita para adicionar um toque divertido às minhas fotos. Seja trocando rostos com amigos ou experimentando diferentes aparências de celebridades, os resultados são sempre hilários e divertidos.",
      name: "Cliff Quan",
      dateText: "2 de março de 2024",
    },
    data2: {
      title: "Como entusiasta de maquiagem",
      content:
        "Como entusiasta de maquiagem, eu uso o PixelHaha para experimentar novos looks antes de me comprometer com eles na vida real. Trocar meu rosto com diferentes personagens me ajuda a visualizar como vários estilos ficarão em mim. É uma ferramenta divertida e prática para quem adora experimentar maquiagem!",
      name: "Anli Brevo",
      dateText: "16 de maio de 2024",
    },
    data3: {
      title: "É fácil usar a troca de rostos em vídeo",
      content:
        "É fácil usar a função de troca de rostos em vídeo para trocar seu rosto com o de outra pessoa. Quer você queira colocar o rosto de uma estrela de cinema na sua cabeça ou substituir seu rosto pelo de um jogador de basquete, esta ferramenta faz o trabalho perfeitamente. Continuem assim!",
      name: "Ada Wu",
      dateText: "19 de abril de 2024",
    },
    data4: {
      title: "Esta ferramenta incrível detecta inteligentemente",
      content:
        "Esta ferramenta incrível detecta inteligentemente rostos em fotos e os substitui perfeitamente por qualquer rosto que você escolher. É como ter seu próprio estúdio criativo pessoal na ponta dos dedos! Com o PixelHaha, trocar rostos em qualquer foto é fácil, permitindo que eu libere minha imaginação sem qualquer dificuldade.",
      name: "Mario Kuper",
      dateText: "24 de janeiro de 2024",
    },
    data5: {
      title: "Sempre achei a edição de fotos desafiadora",
      content:
        "Sempre achei a edição de fotos desafiadora, mas o PixelHaha torna isso fácil! Adoro experimentar as diferentes opções de troca de rostos da IA e ver as combinações hilárias. É uma maneira fantástica de adicionar humor às minhas fotos e manter meus amigos rindo.",
      name: "Chris Jin",
      dateText: "12 de dezembro de 2023",
    },
    data6: {
      title: "A troca de rostos com IA é ideal para criar memes engraçados",
      content:
        "A troca de rostos com IA é ideal para criar memes engraçados, fotos de perfil e vídeos de troca de rostos. O PixelHaha é perfeito não apenas para entretenimento, mas também para a criação de conteúdo envolvente. Ajuda você a captar mais atenção nas redes sociais.",
      name: "Kotláriková",
      dateText: "24 de março de 2024",
    },
  },
  faq: {
    title: "Perguntas Frequentes",
    details: "Detalhes  >",
    data1: {
      question: "O que é o PixelHaha?",
      answer:
        "O PixelHaha é uma plataforma de IA visual que utiliza tecnologia avançada para trocar rostos, retocar, melhorar, colorir, corrigir e cartoonizar imagens automaticamente, sem a necessidade de ferramentas complexas de edição de fotos, como o Photoshop. Utilizando algoritmos de IA de ponta, o PixelHaha simplifica o processamento de fotos, economizando tempo, energia e custos para usuários individuais e empresariais que precisam de edição em massa de fotos.",
    },
    data2: {
      question: "Como funciona uma ferramenta de Troca de Rostos com IA?",
      answer:
        "A Troca de Rostos com IA depende de algoritmos sofisticados de inteligência artificial para analisar minuciosamente as imagens de origem, reconhecer características faciais e substituí-las perfeitamente por outro rosto, mantendo a iluminação, os ângulos e as expressões naturais. Isso resulta em trocas de rosto realistas geradas pela IA.",
    },
    data3: {
      question: "Como usar a Troca de Rostos em Vídeo?",
      answer:
        "Primeiro, selecione uma imagem clara de frente como base. Em seguida, escolha o rosto que deseja trocar, seja o seu ou o de uma celebridade. Por fim, inicie o processo de substituição, e o rosto escolhido será colocado perfeitamente na imagem base.",
    },
    data4: {
      question: "Posso substituir meu rosto por qualquer imagem?",
      answer:
        "Sim, com certeza. O PixelHaha permite que você substitua seu rosto por qualquer imagem selecionada gratuitamente. Por exemplo, você pode colocar o rosto de um homem em um retrato feminino ou um rosto envelhecido na foto de um bebê. As possibilidades são infinitas, permitindo que você se torne quem quiser, sem limitações.",
    },
    data5: {
      question: "Como obter o melhor resultado?",
      answer:
        "Para obter resultados ideais com a troca de rostos, siga estas dicas: Selecione uma foto clara com características faciais bem definidas, evitando imagens borradas. Certifique-se de que há apenas um rosto na foto e que ele esteja diretamente voltado para a câmera, sem obstruções de objetos como mãos.",
    },
    data6: {
      question: "Posso trocar rostos online gratuitamente?",
      answer:
        "Absolutamente! Você pode trocar rostos online gratuitamente usando o PixelHaha. Oferecemos planos gratuitos e premium para atender às suas necessidades. Como novo usuário, você receberá três créditos ao se registrar, proporcionando acesso total ao nosso serviço de troca de rostos e recursos adicionais, como recorte de rosto e criação de avatar.",
    },
  },
  choose: {
    delText: "Tem certeza de que deseja excluir este rosto?",
    leftBtnText: "Continuar",
    rightBtnText: "Cancelar",
    overFaces:
      "O upload de rostos atingiu o limite. Exclua outros rostos para continuar.",
    faceAn: "Análise facial...",
    facesuccess: "Sucesso na análise facial",
    facefailed: "Falha na análise facial",
    feedback: "Obrigado pelo seu feedback!",
    batchsupport:
      "Suporte em lote! Você pode fazer uma nova troca de rosto, independentemente do resultado atual.",
    batchsupportAIGirl:
      "Suporte em lote! Pode criar uma nova imagem AI, independentemente do resultado atual.",
    submitting: "Enviando",
    queuing: "Na fila",
    creating: "Criando",
    downloading: "Baixando",
    retryText: "Algo deu errado. Tente novamente mais tarde.",
    retry: "Tentar novamente",
    emailTip:
      "Insira um sufixo de nome de domínio válido (como .com, .net, etc.)",
    noaccount: "Ainda não tem conta?",
    enterPassWord: "Digite a senha",
    loginPassWordErr: "A senha deve conter pelo menos 8 caracteres",
    passWordErr: "Defina a senha com no mínimo 8 caracteres",
    forgotpass: "Esqueceu sua senha?",
    googlesign: "Login com login do Google?",
    resetpassword: "Redefinir senha",
    readyaccount: "já tem uma conta?",
    confirm: "confirme",
    resetpasswordsuccess: "Redefinição de senha com sucesso!",
    senderror: "Erro de envio!",
    sendsuccess: "Envie sucesso!",
    signupfree: "Inscreva-se gratuitamente",
    signupsuccess: "Inscreva-se com sucesso!",
    sendcode: "Enviar Código",
    loginsuccess: "Entrar com sucesso!",
    logingerror: "Erro de Login!",
    aboutS: "cerca de {leftTime}s",
    keepPatient: "Mantenham paciência!",
    needMoretime: "Preciso de mais tempo!",
    aimostDoneKeep: "Quase pronto! Mantenham paciência!",
    usernamePlace: "user{'@'}example.com",
    emailCode: "Código de verificação",
  },
  feedbackDialog: {
    title: "Precisamos do seu feedback para melhorar o PixelHaha.",
    subTitle1: "Quer melhorar?",
    option1: "Análise facial imprecisa sobre arquivos enviados",
    option2: "Não parece",
    option3: "Problemas de detalhes do rosto (distorcidos, olhos, boca etc.)",
    option4: "Tempo lento",
    option5: "Nitidez do resultado",
    txtOption1: "Conteúdo sensível ou perturbador",
    txtOption2: "Violação dos termos de serviço",
    txtOption3: "Relevância imediata",
    txtOption4: "Rosto distorcido",
    txtOption5: "Conteúdo da imagem",
    txtOption6: "Nitidez da imagem",
    txtOption7: "Tempo lento",
    subTitle2: "Quer dizer mais?",
    placeholder: "Outras sugestões...",
    submit: "Enviar",
  },
  infoDialog: {
    advancedFeatures: "Características avançadas",
    advancedFeaturesText:
      "Pague por nossos planos para desbloquear o recurso realista de troca de rosto em vídeo.",
    choosePlan: "Escolha o plano",
    insufficientCredits: "Créditos insuficientes",
    insufficientCreditsText: "Seu saldo de crédito:",
    getMoreCredits: "Obtenha mais créditos",
    videoTooBig: "O vídeo é muito grande",
    videoTooLong: "O vídeo é muito longo",
    videoCannotExceed: "O vídeo não pode exceder",
    inFileSize: "em tamanho de arquivo",
    selectAnotherFile: "Selecione outro arquivo",
    photoTooBig: "A foto é muito grande",
    photoCannotExceed: "A foto não pode exceder",
    tenMin: "10 minutos",
    deleteFile: "Tem certeza de que deseja excluir este arquivo?",
    cancel: "Cancelar",
    confirm: "confirme",
  },
  allRightsReserved: "Todos os direitos reservados.",
  aiGirlIntroductionDetails: "Detalhes de introdução da imagem AI",
  aiGirlHowToUse: "Imagem AI como usar",
  discoverHot: "Descubra pesquisas populares",
  aiGirlFAQDetails: "Detalhes das perguntas frequentes sobre imagens AI",
  lookslikeUploadOpps: {
    title: "Ops!",
    subtitle:
      "Ops! Ultrapasse os limites de créditos gratuitos!\nAssine o plano para usar todos os recursos de forma ilimitada.",
    unlockLimit: "Limite de desbloqueio",
  },
  selectStyle: "Selecione o estilo",
  purchasePopup: {
    title: "Com sucesso!",
    consumerSuccess: "Você ganhou <xx1> créditos",
    subscribeSuccess: "Acesso ilimitado! Aproveite nosso serviço!",
    ok: "OK",
  },
  affiliatePopup: {
    title: "Tutorial do Programa de Afiliados",
    first: "Primeiro",
    second: "Segundo",
    linkHint: "Link do Programa de Afiliados:",
    copy: "Cópia",
    ok: "OK",
  },
  photoEnhanceDetails: "Detalhes de aprimoramento de fotos",
  videoEnhanceDetails: "Detalhes de aprimoramento de vídeo",
  imageEnhancer: "Melhorador de fotos com IA",
  videoEnhancer: "Aprimorador de vídeo de IA",
  socialShareTitle:
    "Uau! Esta imagem feita pelo gerador de imagens de IA é incrível, não é?",
  copySuccess: "Cópia bem-sucedida!",
  email: "E-mail",
  copy: "Cópia",
};
